import { render } from "./InstitutionSelector.vue?vue&type=template&id=12a89e0c"
import script from "./InstitutionSelector.vue?vue&type=script&lang=js"
export * from "./InstitutionSelector.vue?vue&type=script&lang=js"

import "./InstitutionSelector.vue?vue&type=style&index=0&id=12a89e0c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__